module.exports = __webpack_public_path__ + "img/Bartek_K1.207c8050.jpg";